/* eslint-disable eslint-comments/disable-enable-pair -- needed */
import React from 'react';
import { Heading, Layout, Link } from '@americanexpress/dls-react';
import { FormattedMessage } from 'react-intl';
import AnalyticsClick from '../../../shared/components/analyticsClick';

export function BenefitsHeading(props) {
  const accKey = props?.accKey;
  const cardname = props?.cardname;

  return (
    <Layout innerContainerClassName="flex flex-column flex-justify-center pad-2 pad-3-lg-up text-nowrap" className="margin-2-tb margin-3-tb-lg-up">
      <div className="flex flex-justify-between flex-wrap flex-align-center">
        <Heading level={1} variant="sans-large-book">
          <FormattedMessage id="view-all.card-banner.explore-benefits" defaultMessage="Explore Benefits" />
        </Heading>
        {cardname?.includes('centurion') && props?.locale === 'en-US'
          ? (
            <AnalyticsClick element={`${cardname}>>centurion-button`}>
              <Link
                id="Centurion"
                name="Centurion"
                identifier="Filter Bar"
                href={`https://americanexpress.com/us/benefits/centurion/?account_key=${accKey}`}
              >
                <FormattedMessage id="view-all.card-banner.go-to" defaultMessage="Go to" /> Centurion.com
              </Link>
            </AnalyticsClick>
          ) : ''}
      </div>
    </Layout>
  );
}
